const config = {
  paymentMethods: {
    invoice: '0',
    cash: '1',
    online: '2',
  },
  paymentMethodVerbose: {
    online: 'Płatność ING',
  },
  paymentStatus: {
    success: 2,
    failure: 3,
  },
  paymentStatusVerbose: {
    newPayment: 'Nowa płatność',
    failedPayment: 'Nieudana płatność',
  },
};

export default config;
